module.exports = __webpack_public_path__ + "static/img/medical_11.5c7e1fff.jpg";